export const baseWidthReference = 1448;

export const getDefaultAnimationConfig = () =>
  ({
    overlay_content: {
      fontSize: 37,
      letterSpacing: 8,
    },
    texts: [
    /* #text0 */
      {
        top: 384,
        left: 746,
        width: 669,
        height: 300,
      },
      /* #text1 */
      {
        top: 380,
        left: 122,
        width: 669,
        height: 300,
      },
      /* #text2 */
      {
        top: 377,
        left: 531,
        width: 868,
        height: 300,
      },
      /* #text3 */
      {
        top: 507,
        left: 672,
        width: 749,
        height: 300,
      },
      /* #text4 */
      {
        top: 380,
        left: 30,
        width: 749,
        height: 300,
      },
      /* #text5 */
      {
        top: 561,
        left: 764,
        width: 659,
        height: 250,
      },
      /* #text6 */
      {
        top: 319,
        left: 17,
        width: 687,
        height: 467,
      },
      /* #text7 */
      {
        top: 295,
        left: 23,
        width: 828,
        height: 493,
      },
      /* #text8 */
      {
        top: 277,
        left: 620,
        width: 789,
        height: 510,
      },
      /* #text9 */
      {
        top: 329,
        left: 19,
        width: 1039,
        height: 470,
      },
      /* #text10 */
      {
        top: 245,
        left: 639,
        width: 791,
        height: 540,
      },
      /* #text11 */
      {
        top: 327,
        left: 700,
        width: 719,
        height: 457,
      },
      /* #text12 */
      {
        top: 281,
        left: 706,
        width: 719,
        height: 520,
      },
      /* #text13 */
      {
        top: 278,
        left: 26,
        width: 1089,
        height: 520,
      },
      /* #text14 */
      {
        top: 334,
        left: 20,
        width: 1009,
        height: 440,
      },
      /* #text15 */
      {
        top: 26,
        left: 26,
        width: 933,
        height: 396,
      },
      /* #text16 */
      {
        top: 389,
        left: 26,
        width: 939,
        height: 400,
      },
      /* #text17 */
      {
        top: 389,
        left: 26,
        width: 1010,
        height: 400,
      },
      /* #text18 */
      {
        top: 337,
        left: 26,
        width: 939,
        height: 453,
      },
      /* #text19 */
      {
        top: 293,
        left: 749,
        width: 669,
        height: 500,
      },
      /* #text20 */
      {
        top: 290,
        left: 26,
        width: 949,
        height: 500,
      },
      /* #text21 */
      {
        top: 288,
        left: 26,
        width: 791,
        height: 500,
      },
      /* #text22 */
      {
        top: 289,
        left: 729,
        width: 689,
        height: 500,
      },
      /* #text23 */
      {
        top: 335,
        left: 26,
        width: 829,
        height: 459,
      },
      /* #text24 */
      {
        top: 290,
        left: 26,
        width: 1219,
        height: 500,
      },
      /* #text25 */
      {
        top: 251,
        left: 26,
        width: 1122,
        height: 550,
      },
      /* #text26 */
      {
        // Game of Thrones Logo
        top: 264,
        left: 0,
        width: 1448,
        height: 283,
      },
      /* #text27 */
      {
        top: 26,
        left: 26,
        width: 1400,
        height: 767,
      },
      /* #text28 */
      {
        top: 26,
        left: 26,
        width: 1400,
        height: 767,
      },
    ],
  });

